module.exports = __webpack_public_path__ + "img/montage4mini.bb1fad2e.webp";